<div class="settings-main-container">
  <div class="header">
    <div class="header-content">
      <div class="header-text">
        <h2>{{ 'SETTINGS.TITLE' | translate }}</h2>
        <p class="subtitle">{{ 'SETTINGS.DESCRIPTION' | translate }}</p>
      </div>
    </div>
  </div>

  <div class="content">
    <div class="items-grid">
      <div class="item-card settings-card">
        <div class="card-body">
          <div class="settings-group">
            <div class="setting-item">
              <mat-checkbox 
                [(ngModel)]="settings.showRecentNotifications"
                (change)="onSettingChange('showRecentNotifications', settings.showRecentNotifications)"
                color="primary">
                <div class="setting-content">
                  <div class="setting-header">
                    <mat-icon class="setting-icon">notifications</mat-icon>
                    <span class="setting-title">{{ 'SETTINGS.SHOW_RECENT_NOTIFICATIONS' | translate }}</span>
                  </div>
                  <p class="setting-description">{{ 'SETTINGS.RECENT_NOTIFICATIONS_DESCRIPTION' | translate }}</p>
                </div>
              </mat-checkbox>
            </div>

            <div class="setting-item">
              <mat-checkbox 
                [(ngModel)]="settings.showQuickActions"
                (change)="onSettingChange('showQuickActions', settings.showQuickActions)"
                color="primary">
                <div class="setting-content">
                  <div class="setting-header">
                    <mat-icon class="setting-icon">speed</mat-icon>
                    <span class="setting-title">{{ 'SETTINGS.SHOW_QUICK_ACTIONS' | translate }}</span>
                  </div>
                  <p class="setting-description">{{ 'SETTINGS.QUICK_ACTIONS_DESCRIPTION' | translate }}</p>
                </div>
              </mat-checkbox>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <button class="reset-btn" (click)="resetToDefaults()">
            <mat-icon>restore</mat-icon>
            {{ 'SETTINGS.RESET_DEFAULTS' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>